import React from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const TransactionsModal = ({ show, onClose }) => {
  return (
    <>
      <Modal
        className="custom-modal modal-سة"
        show={show}
        onHide={onClose}
        centered
      >
        <Modal.Header className="custom-close ">
          <Modal.Title className="text-primary bold fs-1 ">
            تحليل البيانات{" "}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={onClose}
          >
            <span aria-hidden="true">×</span>
          </button>
        </Modal.Header>
        <hr className="text-primary" />
        <Modal.Body className="fs-4 text-center">
          تم تحليل البيانات بنجاح !{" "}
        </Modal.Body>
        <Modal.Footer>
          <Link
            className="btn btn-primary w-75"
            to="/bookbot-before-post"
            onClick={onClose}
          >
            اضغط للمعاينة
          </Link>
        </Modal.Footer>
      </Modal>
      {/* Warning Alert Modal */}
      {/* <div
        id="responseModal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-body p-4">
              <div className="text-center">
                <i className="dripicons-warning h1 text-warning" />
                <h4 className="mt-2">تم تحليل البيانات </h4>
                <p className="mt-3">الطباعة غير متاحة في النسخة المجانية</p>
                <Link
                  type="button"
                  className="btn btn-warning my-2"
                  to="/ai-file-transactions"
                >
                  اضغط للمعاينة
                </Link>
              </div>
            </div>
          </div>
        
        </div>
   
      </div> */}
      {/* /.modal */}
    </>
  );
};

export default TransactionsModal;
